import { Phone, MessageCircle } from "lucide-react";
import { useSettings } from "@/lib/hooks";

export default function FloatingActions() {
  const s = useSettings();
  return (
    <div className="fixed right-4 bottom-20 lg:bottom-6 z-30 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={`https://wa.me/${s?.company_whatsapp || ""}`}
        target="_blank"
        rel="noreferrer"
        className="w-14 h-14 rounded-full bg-whats hover:bg-whats-hover text-white flex items-center justify-center shadow-float transition-colors"
        aria-label="WhatsApp"
        data-testid="fab-whatsapp"
      >
        <MessageCircle size={24} />
      </a>
      <a
        href={`tel:${s?.company_phone_raw || ""}`}
        className="w-14 h-14 rounded-full bg-urgent hover:bg-urgent-hover text-white flex items-center justify-center shadow-float transition-colors"
        aria-label="Appeler"
        data-testid="fab-call"
      >
        <Phone size={24} />
      </a>
    </div>
  );
}
